export default "__VITE_ASSET__8BWmIQpx__"